const alphaNumericCleaner = (input) => {
  return input.replace(/[^0-9a-z-A-Z ]/g, '').replace(/ +/, ' ')
}

export {
  alphaNumericCleaner
}
